

export const deliveryZonesViews = self => ({

})